export const related = {
  status: { id: 'bcfe4314-96d3-466b-97fe-d2510cc48c85', data: [] },
  type: { id: 'aa7ba21f-d664-45ce-8d86-ca03ba3e0042', data: [] },
  group: { id: 'a545f394-1ba1-4f91-8ef7-63eb3dd2f47f', data: [] },
  subgroup: { id: 'fa1abc09-f273-45fc-a13b-20ec4eb1e15c', data: [] },
  contractor: { id: 'ef021b44-a650-478e-a25f-ace1e9b545ca', data: [] }
}
